<template>
	<div id="plangraduate">
		<HrrBreadcrumb PMname="岗位计划管理" CMname="毕业生接收情况明细" />
		<HrrDetailLayout>
			<template slot="head" >
				{{title}}
			</template>
			<template slot="Form" >
				<el-form status-icon :model="postform" ref="postform" :rules="postrules" label-width="160px" class="el-form-module" :hide-required-asterisk="!isAddOrEdit" >
                    <el-row :gutter="20">
                        <el-col :span="8">
							<el-form-item label="计划：" prop="planId">
								<el-select v-model="postform.planId"  placeholder="请选择"   v-if="isAddOrEdit">
									<el-option v-for="item in planData" :key="item.planId" :label="item.planName" :value="item.planId">
									</el-option>
								</el-select>
                                <span v-if="!isAddOrEdit">
                                    {{planform.planName}}
                                </span>
							</el-form-item>
                            <el-form-item label="接收年份" prop="year">
                                <el-date-picker v-model="postform.year"  type="year" value-format="yyyy" v-if="isAddOrEdit"></el-date-picker>
                                <span v-if="!isAddOrEdit">
                                    {{postform.year}}
                                </span>
                            </el-form-item>
                            <el-form-item label="单位名称" prop="companyName">
                                <el-input v-model="postform.companyName" v-if="isAddOrEdit" type="textarea"></el-input>
                                <span v-if="!isAddOrEdit">
                                    {{postform.companyName}}
                                </span>
                            </el-form-item>
                            <el-form-item label="部门名称" prop="departmentName">
                                <el-input v-model="postform.departmentName" v-if="isAddOrEdit"></el-input>
                                <span v-if="!isAddOrEdit">
                                    {{postform.departmentName}}
                                </span>
                            </el-form-item>
                            <el-form-item label="工作岗位(职位)" prop="post">
                                <el-input v-model="postform.post" v-if="isAddOrEdit"></el-input>
                                <span v-if="!isAddOrEdit">
                                   {{postform.post}}
                                </span>
                            </el-form-item>
                            <el-form-item label="姓名" prop="userName">
                                <el-input v-model="postform.userName" v-if="isAddOrEdit"></el-input>
                                <span v-if="!isAddOrEdit">
                                    {{postform.userName}}
                                </span>
                            </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="所学专业" prop="major">
                                    <el-input v-model="postform.major" v-if="isAddOrEdit" type="textarea"></el-input>
                                    <span v-if="!isAddOrEdit">
                                        {{postform.major}}
                                    </span>
                                </el-form-item>
                                <el-form-item label="是否主业" prop="isMain">
                                    <el-radio-group v-model="postform.isMain" >
                                        <el-radio :label="1" :disabled="!isAddOrEdit">是</el-radio>
                                        <el-radio :label="0" :disabled="!isAddOrEdit">否</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                                <el-form-item label="是否在岗" prop="isOnjob">
                                    <el-radio-group v-model="postform.isOnjob" >
                                        <el-radio :label="1" :disabled="!isAddOrEdit">是</el-radio>
                                        <el-radio :label="0" :disabled="!isAddOrEdit">否</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                                <el-form-item label="备注" prop="remark">
                                    <el-input v-model="postform.remark" v-if="isAddOrEdit"></el-input>
                                    <span v-if="!isAddOrEdit">
                                        {{postform.remark}}
                                    </span>
                                </el-form-item>
                                <span v-if="!isAddOrEdit">
                                   {{postform.status_str}}
                                </span>
                            </el-form-item>
                            </el-col>

                    </el-row>
				</el-form>
			</template>
			<template slot="buttons" >
				<el-button type="primary" @click="submitMForm('postform')" v-if="isAddOrEdit">提 交</el-button>
				<el-button  @click="resetMForm('postform')" v-if="isAddOrEdit">重 置</el-button>
				<el-button type="info" @click="returnMForm()" >返 回</el-button>
			</template>
		</HrrDetailLayout>
	</div>
</template>
<script>
	export default {
		name: 'plan_graduates_Detail',
		data(){
			return{
				postform:{
					year:"",
					major:"",
					companyName:"",
					departmentName:"",
                    post:"",
                    isOnjob:"",
                    remark:"",
					userName:"",
                    isMain:"",
					status:"",
                    status_str:"",
                    gReviewType_str:"",
                    gSourceType_str:"",
                    gReviewData:"",
                    gSourceData:"",
                    planId:"",
				},
                planform:{
                    planId:"",
                    planName:""
                },
                planData: [],
				postrules:{
					planId:[ { required: true, message: '请选择计划' , trigger: 'blur'}],
					year:[ { required: true, message: '请选择接收年份' , trigger: 'blur'}],
					companyName:[ { required: true, message: '请输入单位名称' , trigger: 'blur'}],
                    departmentName:[ { required: true, message: '请输入部门名称' , trigger: 'blur'}],
                    post:[ { required: true, message: '请输入工作岗位' , trigger: 'blur'}],
                    major:[ { required: true, message: '请输入专业' , trigger: 'blur'}],
                    isMain:[ { required: true, message: '请选择是否主业' , trigger: 'blur'}],
                    isOnjob:[ { required: true, message: '请选择是否在岗' , trigger: 'blur'}]
                },
				title:"",
				isAddOrEdit:true,
                educationData:[],
				postDiploma:[],
				reviewType:[],
				graduateBirth:[]
			}
		},
		methods:{
			submitMForm:function(formName){
                var Hrrtype=this.$route.params.type; //类型
                if(Hrrtype=="edit"){Hrrtype="modify"}
				this.$refs[formName].validate((valid) =>{
					if (valid) {
						var Vuethis=this;
						var postUrl = (Hrrtype == "modify") ? this.$api.plan.reportGmodify : this.$api.plan.reportGAdd ;
						this.$hrraxios.post(postUrl,this.postform)
						.then(function(response){
                            var data=response.data;
                            console.log(data)
							if(data.success==true)
							{
                                Vuethis.$message.success("提交成功");
                                //Vuethis.
								Vuethis.$router.push({path:'/plan/report/graduates'});
							}else{
                                Vuethis.$message.error(data.prompt);
                            }
						}).catch(function(error){
							console.log(error);
						})
					} else {
						return false;
					}
				});
			},
			resetMForm:function(formName) {
				this.$refs[formName].resetFields();
			},
			returnMForm:function(){
				this.$router.go(-1);
			},
			initData:function(){
				var Hrrtype=this.$route.params.type; //类型
				if(Hrrtype!="add"){
                    var row=this.$route.meta.row;
                    // console.log(row)
                    this.postform = row;
                    //this.postform.planform.planId = row.planId;
                    this.planform.planId = row.planId;
					this.$route.meta.row={};
				}
				if(Hrrtype=="view"){
					this.title="查看功能";
					this.isAddOrEdit=false;
				}
				if(Hrrtype=="edit"){
					this.title="编辑功能";
					this.isAddOrEdit=true;
				}
				if(Hrrtype=="add"){
					this.title="新增功能";
					this.isAddOrEdit=true;
				}
				var myVuethis=this;
				this.$hrraxios.get(this.$api.plan.planList, {
                        params: {}
                    })
                    .then(function(response) {
						var data = response.data;
						// console.log(data)
                        if (data.success == true) {
                            myVuethis.planData = data.data;
							//myVuethis.postform.planform.planId = data;
							// console.log(myVuethis.postform.planData)
                            for(var i=0;i<data.data.length;i++){
                                if(myVuethis.planform.planId==data.data[i].planId){
                                   myVuethis.planform.planName=data.data[i].planName;
                                }
                            }
                        } else {
                            Vuethis.$message.error(data.prompt);
                        }
                    })
                    .catch(function(error) {
                        console.log(error);
                    });

			},

		},
		created:function(){
			this.initData();
		}
	}
</script>
<style scoped>
.el-form-module{width:100%;}
</style>
